import { createApi, fetchBaseQuery, BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { browserName, browserVersion, osName, osVersion } from 'react-device-detect';

// Import store
import { RootState } from 'store/store';

// Import actions
import { signOut } from 'store/actions';

// Import helpers
import { getDeviceUID } from 'helpers/headers';

const coreQuery = fetchBaseQuery({
	baseUrl: process.env.REACT_APP_API_URL,
	prepareHeaders: (headers, api) => {
		const uuid = getDeviceUID();
		const state = api.getState() as RootState;

		headers.set('Access-Control-Allow-Origin', '*');
		headers.set('Content-Type', 'application/json');
		headers.set('Accept', 'application/json');
		headers.set('API-DeviceUID', uuid);
		headers.set('API-Device', `${browserName}; ${browserVersion}; ${osName}; ${osVersion}; ${osName}; ${osVersion};`);

		if (state.auth.authenticate) {
			headers.set('authorization', `Bearer ${state.auth.authenticate.token}`);
		}

		return headers;
	},
	// Add possibility to pass special characters required by backend to query string (without default URL encoding)
	paramsSerializer: (params) => decodeURIComponent(new URLSearchParams([...Object.entries(params)]).toString())
});

const dynamicBaseQuery: BaseQueryFn<FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
	const { auth } = api.getState() as RootState;
	const system = args.body?.system ?? args.params?.system ?? auth.authenticate?.system ?? process.env.REACT_APP_SYSTEM;

	const result = await coreQuery(
		{
			...args,
			params: { ...args.params, system, platform: 'BROWSER' }
		},
		api,
		extraOptions
	);

	// Handle globally unauthorized error
	if (result.error?.status === 401) {
		api.dispatch(signOut(false));
	}

	return result;
};

export const api = createApi({
	baseQuery: dynamicBaseQuery,
	keepUnusedDataFor: 600,
	endpoints: () => ({})
});
